<template>
    <div class="open-applications app__page">
        <div class="open-applications__page-header app__page-header">
            <sah-button v-if="$features.addProjects" @click.native="newProject" class="app-page-header__button">
                {{ $tc("openApplications.createProject") }}
            </sah-button>
            <project-selector
                class="open-applications__project-selector"
                :projects="projects"
                v-model="currentProjectId"
            ></project-selector>
        </div>
        <div v-if="currentProject" class="open-applications__cards-list">
            <project-show :project="currentProject" @edit="editProject"></project-show>
            <project-applications></project-applications>
        </div>
        <project-edit
            v-if="isEditing"
            :project="editedProject"
            :operation="editOperation"
            @cancel="closeEdit"
            @end="closeEdit"
        ></project-edit>
    </div>
</template>

<script>
import {store, SahButton} from "atom";
import {EDIT_OPERATION_STORE, EDIT_OPERATION_UPDATE} from "../constants";
import ProjectApplications from "../components/ProjectApplications";
import ProjectShow from "../components/ProjectShow";
import ProjectEdit from "../components/ProjectEdit";
import ProjectSelector from "../components/ProjectSelector";
const {createNamespacedHelpers} = store;
const {mapState, mapGetters} = createNamespacedHelpers("arcman");

/**
 * Renderer for the landing page of the application
 */
export default {
    name: "open-applications",
    components: {
        ProjectApplications,
        ProjectEdit,
        ProjectSelector,
        ProjectShow,
        SahButton,
    },
    computed: {
        ...mapGetters({showSpinner: "showProjectsSpinner"}),
        ...mapState(["projects", "arcologyConstants"]),
        currentProject() {
            return this.projects.find(element => element.id === this.currentProjectId);
        },
    },
    watch: {
        showSpinner(newValue, oldValue) {
            this.$emit("showSpinner", newValue);
        },
    },
    data() {
        return {
            currentProjectId: "",
            isEditing: false,
            editOperation: "",
            editedProject: {},
        };
    },
    methods: {
        editProject(event) {
            this.isEditing = true;
            this.editOperation = EDIT_OPERATION_UPDATE;
            this.editedProject = Object.assign(this.getProjectTemplate(), event);
        },
        newProject() {
            this.isEditing = true;
            this.editOperation = EDIT_OPERATION_STORE;
            this.editedProject = this.getProjectTemplate();
        },
        getProjectTemplate() {
            const project = JSON.parse(JSON.stringify(this.arcologyConstants.PROJECT_TEMPLATE));
            project.type = this.$settings.dataModels.DEFAULT_PROJECT_TYPE;
            project.warehouseId = this.$settings.dataModels.DEFAULT_WAREHOUSE_ID;
            return project;
        },
        closeEdit() {
            this.isEditing = false;
            this.editedProject = {};
        },
    },
};
</script>
<style lang="scss" scoped>
.open-applications::v-deep {
    .open-applications__page-header {
        @apply flex flex-row items-center pt-6 pb-4;
    }

    .open-applications__project-selector {
        @apply flex flex-row items-center;
        width: calc(100% - #{$max-button-width});
        @screen md {
            width: 20%;
        }

        .sah-form-select-group__label {
            @apply mr-4;
        }

        .sah-form-select-group__select {
            @apply w-full;
        }
    }

    .open-applications__cards-list {
        @apply grid;
        column-gap: 1rem;
        row-gap: 1em;
        grid-template-columns: 2fr 1fr;
    }
}
</style>
